
import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import { isNewerVersionAvailable } from "./router";

@Component
export default class App extends Vue {
  async created() {
    this.$store.commit("setting/setNewVersionValue", this.$cookies.get("version"));
    await this.updateTimestamp();
    this.$root.$on("bv::modal::hide", (id, modalId) => {
      if (this.$store.state.system.modalToDisplay === modalId)
        this.$store.commit("system/setCurrentModal", null);
    });
  }

  async updateTimestamp() {
    const currentTimestamp = this.$cookies.get("renew.timestamp");
    const now = new Date();
    if (
      moment(now).isAfter(
        moment
          .unix(currentTimestamp / 1000)
          .add(process.env.VUE_APP_DISPLAY_NEW_VERSION_IN_HOURS, "hours")
      )
    ) {
      this.$cookies.set("renew.timestamp", now.getTime());
    }
    if (
      moment(now).isAfter(
        moment
          .unix(currentTimestamp / 1000)
          .add(process.env.VUE_APP_CHECK_VERSION_IN_MINUTES, "minutes")
      )
    ) {
      await isNewerVersionAvailable();
    }
  }
}
